/**
 * @react-pdf/renderer expects Node's Buffer in some browser code paths.
 * Safe no-op if the buffer package is not installed.
 */
export function ensureBufferPolyfill() {
  if (typeof window === 'undefined') return;
  if (typeof window.Buffer !== 'undefined') return;
  try {
    // eslint-disable-next-line global-require
    const { Buffer } = require('buffer');
    window.Buffer = Buffer;
  } catch (e) {
    console.error(
      '[native-pdf] Buffer polyfill failed — PDF export will not work until the buffer package is installed:',
      e,
    );
  }
}

ensureBufferPolyfill();
